module.exports = {"510722101":"潼川镇","510722104":"塔山镇","510722106":"龙树镇","510722107":"石安镇","510722108":"富顺镇","510722109":"三元镇","510722110":"秋林镇","510722112":"新德镇","510722113":"新生镇","510722114":"鲁班镇","510722115":"景福镇","510722116":"紫河镇","510722118":"观桥镇","510722119":"郪江镇","510722120":"中新镇","510722121":"古井镇","510722123":"西平镇","510722124":"八洞镇","510722126":"乐安镇","510722127":"建平镇","510722131":"中太镇","510722132":"金石镇","510722133":"新鲁镇","510722135":"刘营镇","510722136":"灵兴镇","510722137":"芦溪镇","510722138":"立新镇","510722140":"永明镇","510722141":"建中镇","510722145":"老马镇","510722151":"北坝镇","510722201":"忠孝乡","510722204":"断石乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510722.json
// module id = 2433
// module chunks = 0